<div class="matrix_layoutMain matrix_layoutUseMatrix container" v-bind:class="getClassNameContainer">
    <div class="row">
        <div class="col-md-12 matrix_layoutMatrixContainerColMain">
            <div class="matrix_productPartsMainContainer matrix_table">
                <appOptionsContainer></appOptionsContainer>
                <div class="matrix_layoutAdminDefaultSelectionActions">
                    <appApplyDefaultSelection></appApplyDefaultSelection>
                    <appResetSelectionButton></appResetSelectionButton>
                </div>
            </div>
        </div>
    </div>
</div>
